import React from "react";
import Page from "./Containers/Page";
import Routes from "Configs/routes";
import withSEO from "HOC/withSEO";

@withSEO(Routes.AddReview)
export default class AddReview extends React.Component {
	render() {
		let seoData = this.props.seoData;
		return <Page h1={seoData && seoData.h1} />;
	}
}
